import { render, staticRenderFns } from "./DataStepSix.vue?vue&type=template&id=9ed11cd0&scoped=true&"
import script from "./DataStepSix.vue?vue&type=script&lang=js&"
export * from "./DataStepSix.vue?vue&type=script&lang=js&"
import style0 from "./DataStepSix.vue?vue&type=style&index=0&id=9ed11cd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed11cd0",
  null
  
)

export default component.exports